import { LockClosedIcon } from "@heroicons/react/20/solid";

// The pill follows `isClosed` of the part only. A Draft unlock keeps the part editable but does not
// reopen the closing, so the pill stays.
export function ClosedMonthPill() {
	return (
		<span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-gray-200 px-2 py-0.5 text-xs font-medium text-gray-700">
			<LockClosedIcon aria-hidden className="size-3" />
			Monat geschlossen
		</span>
	);
}
